import { defaultLocalStorageAdapter } from 'src/shared/graphql';
import { useAuthenticateWithCookieMutation } from 'src/shared/graphql/generated';
import { useRefreshHomeownerSession } from 'src/shared/graphql/hooks';

export const useAuthenticateWithToken = () => {
  const [authenticateWithCookie] = useAuthenticateWithCookieMutation();
  const refreshSession = useRefreshHomeownerSession();

  const authenticateWithToken = async (token: string) => {
    const response = await authenticateWithCookie({
      context: {
        headers: {
          'X-JWT-AUTH': `Bearer ${token}`,
        },
      },
    });

    const { accessToken, refreshToken } =
      response?.data?.authenticateWithCookie?.jwt || {};

    if (accessToken && refreshToken) {
      await defaultLocalStorageAdapter.setAccessToken(accessToken);
      await defaultLocalStorageAdapter.setRefreshToken(refreshToken);
      await refreshSession();
      return true;
    }

    return false;
  };

  return authenticateWithToken;
};
